export default "__VITE_ASSET__9WeVzLQT__"